import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UserLandingItem } from '../user-landings-models';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { UpaService } from 'projects/common/services/upa.service';

@Component({
  selector: 'user-landing-card',
  template: `

    <a @fade *ngIf="!userLandingCard.deleted" class="eva-3-card -eva-3-shadow-line-hover" (click)="trackClick()"
       [href]="userLandingCard.landing_url" target="_blank" rel="nofollow">

      <div class="user-landing-card-picture">
        <img *ngIf="userLandingCard.city_picture" [src]="userLandingCard.city_picture" alt="" loading="lazy">

        <eva-button *ngIf="withDeleteButton" class="-eva-3-icon-sm user-landing-delete-button"
                    [options]="{icon: 'trash', type: '-dark', circle: true}"
                    (clickEvent)="doDelete($event, userLandingCard);"
                    [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
                    [upaData]="getUpaDataForDeletion()"></eva-button>

      </div>

      <div class="user-landing-card-info -eva-3-p-xlg">

        <div class="user-landing-card-header eva-3-h4">{{ userLandingCard.city_name }}</div>

        <div class="user-landing-card-dates">
          <i class="eva-3-icon-calendar -eva-3-mr-xsm dates-icon"></i>
          <span *ngIf="userLandingCard.from_date_description"
                class="eva-3-body-2 user-landing-card-dates-description">{{ userLandingCard.from_date_description }}
            - {{ userLandingCard.to_date_description }}</span>
          <span *ngIf="userLandingCard.days"
                class="eva-3-body-2">{{ userLandingCard.days }} {{ 'userLandings.card.days' | translate }}</span>
        </div>

        <button *ngIf="withActionButton" class="eva-3-btn-ghost -md wizumen-spacing" [name]="'userLandings.createNewTrip' | translate">
          <em class="btn-text wizumen-footer-link-text">{{'userLandings.createNewTrip' | translate}}</em>
        </button>

        <div *ngIf="userLandingCard.trip_type && userLandingCard.adults" class="user-landing-card-trip-type">
          <i class="eva-3-icon-{{tripTypeIcons[userLandingCard.trip_type]}} -eva-3-mr-xsm"></i>
          <span class="eva-3-body-2">{{ 'userLandings.tripType.' + userLandingCard.trip_type | translate }}
            , {{ userLandingCard.adults }} {{ adultsKey | translate }}{{ (userLandingCard.minors && userLandingCard.minors > 0) ? ', ' + userLandingCard.minors + ' ' + (minorsKey | translate) : '' }} </span>
        </div>

      </div>

    </a>
  `,
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0 }))
      ])
    ]),
  ],
  styleUrls: ['./user-landing-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserLandingCardComponent implements OnInit {
  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() moduleIndex: number;
  @Input() withDeleteButton: boolean = true;

  @Input() userLandingCard: UserLandingItem;
  @Input() url: string;
  @Input() upaData: any;
  @Input() withActionButton: boolean = false;

  @Output() deleteEvent: EventEmitter<UserLandingItem> = new EventEmitter();

  transformedUrl: string;
  imageSize = "700x325";
  tripTypeIcons = {
    "ALONE": "user",
    "COUPLE": "two-hearts",
    "FRIENDS": "users",
    "FAMILY": "family",
  };
  adultsKey = "userLandings.adult";
  minorsKey = "userLandings.minor";

  constructor(
    public landingModelService: LandingModelService,
    public mediaPictureService: MediaPictureService,
    private upaService: UpaService) {}

  ngOnInit(): void {
    this.userLandingCard.city_picture = this.userLandingCard.city_picture + '/' + this.imageSize;
    this.adultsKey +=  (this.userLandingCard.adults > 1? 's' : '');
    this.minorsKey +=  (this.userLandingCard.minors > 1? 's' : '');
  }

  trackClick(){
    this.upaService.trackClickTopic({
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      uniqueId: this.uniqueId,
      label: 'TRIPCARD_CLICK',
      href: this.userLandingCard.landing_url,
      ...this.upaData});
  }

  doDelete($event, userLandingCard){
    $event.preventDefault();
    $event.stopPropagation();
    this.deleteEvent.emit(userLandingCard)
  }

  getUpaDataForDeletion(){
    return {...this.upaData, label: 'SHOW_DELETION_MODAL'};
  }

}
